import React from 'react';

import { Button } from '@components/Button/Button';
import { Paragraph } from '@components/Paragraph/Paragraph';
import { SimpleCard } from '@components/SimpleCard/SimpleCard';
import { Text } from '@components/Text/Text';

import styles from './BrandAssets.module.scss';
import DownloadIcon from '@icons/download.svg';

const assetsBox = [
  {
    title: 'Logo kit',
    text: 'Logotype as file scalable to any display size (SVG) and as an optimized set of bitmap files (PNG).',
    href: '/logo-kit.zip',
  },
  {
    title: 'Image kit',
    text: 'High-resolution images of company CEO Zdenek Cendra and company workplace.',
    href: '/image-kit.zip',
  },
];

export const BrandAssets: React.FC = () => (
  <div className={styles.wrapper}>
    {assetsBox.map(({ title, text, href }) => (
      <SimpleCard key={title} className={styles.card} height="full" size={48} theme="primary">
        <Text align="left" className="mb-2" color="gray900" size={30} tag="h3" weight="bold">
          {title}
        </Text>
        <Paragraph className="mb-8">{text}</Paragraph>
        <Button
          href={href}
          icon={<DownloadIcon />}
          size="md"
          theme="button"
          variant="secondary"
          download
        >
          Download
        </Button>
      </SimpleCard>
    ))}
  </div>
);
